import { t } from 'i18next';
import { useRevealOnScroll } from 'src/shared';

export default function CallToActionComponent() {
  const eyebrowRef = useRevealOnScroll<HTMLSpanElement>();
  const headlineRef = useRevealOnScroll<HTMLHeadingElement>();
  const leadRef = useRevealOnScroll<HTMLParagraphElement>();
  const ctaRef = useRevealOnScroll<HTMLDivElement>();
  const statsRef = useRevealOnScroll<HTMLDivElement>();

  return (
    <section className="hero" id="home">
      <div className="wrap">
        <span ref={eyebrowRef} className="eyebrow reveal">
          <span className="dot" />{t('joinPage.v2.hero.eyebrow')}
        </span>
        <h1 ref={headlineRef} className="display reveal">
          {t('joinPage.v2.hero.headlinePre')}{' '}
          <span className="neon">{t('joinPage.v2.hero.headlineMark')}</span>
        </h1>
        <p ref={leadRef} className="lead reveal">{t('joinPage.v2.hero.subhead')}</p>
        <div ref={ctaRef} className="hero__cta reveal">
          <a className="btn btn--primary" href="#events">
            {t('joinPage.v2.hero.cta1')} <span className="arr">→</span>
          </a>
          <a className="btn btn--ghost" href="#how">
            {t('joinPage.v2.hero.cta2')}
          </a>
        </div>
        <div ref={statsRef} className="stats reveal">
          <div className="stat">
            <b>{t('joinPage.v2.hero.stat1Value')}</b>
            <span>{t('joinPage.v2.hero.stat1Label')}</span>
          </div>
          <div className="stat">
            <b>{t('joinPage.v2.hero.stat2Value')}</b>
            <span>{t('joinPage.v2.hero.stat2Label')}</span>
          </div>
          <div className="stat">
            <b>{t('joinPage.v2.hero.stat3Value')}</b>
            <span>{t('joinPage.v2.hero.stat3Label')}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
